module.exports = __webpack_public_path__ + "static/media/littleBird.2135e396.jpg";